/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import {motion, useMotionTemplate, useMotionValue} from "motion/react";

function MouseSpotlight({
                            children,
                            spotlightColor = "rgba(14, 165, 233, 0.15)",
                            spotlightSize = "650",
                            className,
                            onClick
                        }) {


    let mouseX = useMotionValue(0);
    let mouseY = useMotionValue(0);

    function handleMouseMove({
                                 currentTarget,
                                 clientX,
                                 clientY,
                             }) {
        let {left, top} = currentTarget.getBoundingClientRect();

        mouseX.set(clientX - left);
        mouseY.set(clientY - top);
    }


    return (
        <div
            className={`group relative ${className}`}
            onClick={onClick}
            onMouseMove={handleMouseMove}
        >

            {children}
            <motion.div
                className="pointer-events-none absolute -inset-px rounded-xl opacity-0 transition duration-300 group-hover:opacity-100 z-10"
                style={{
                    background: useMotionTemplate`
            radial-gradient(
              ${spotlightSize}px circle at ${mouseX}px ${mouseY}px,
               ${spotlightColor},
              transparent 80%
            )
          `,
                }}
            />
        </div>
    );

}

MouseSpotlight.propTypes = {
    spotlightColor: PropTypes.any,
    spotlightSize: PropTypes.any,
    className: PropTypes.any,
    children: PropTypes.any,
};

export default MouseSpotlight;